import { SesamiSlotObject } from '@/@types/calendar';
import { format } from 'date-fns/format';
import { useAtom, useSetAtom } from 'jotai';
import React, { useCallback, useMemo } from 'react';
import { selectedTimeSlotAtom } from './calendar-atoms';
import { cn } from '@/entrypoints/utils';

type Props = {
  day: Date;
  slot: SesamiSlotObject['slots'][number];
};

function CalendarTimeSlot({ day, slot }: Props) {
  const [selectedTimeSlot, setSelectedTimeSlot] = useAtom(selectedTimeSlotAtom);

  const active = useMemo(
    () => selectedTimeSlot?.startTime === slot.startTime,
    [selectedTimeSlot, slot],
  );

  const handleClick = useCallback(() => {
    setSelectedTimeSlot(slot);
  }, [setSelectedTimeSlot, slot]);

  return slot.status === 'available' ? (
    <button
      type="button"
      className={cn('medispa-calendar_day-times-slot', active ? 'active' : '')}
      data-slot={JSON.stringify(slot)}
      data-day={day.toISOString()}
      onClick={handleClick}
    >
      {format(slot.startTime, 'h:mm aaa')}
    </button>
  ) : null;
}

export default CalendarTimeSlot;
